import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { getAuthenticatedLandingPath } from '../utils/permissionLanding';

interface TwoFactorAuthGuardProps {
    children: ReactNode;
}

const TwoFactorAuthGuard: FC<TwoFactorAuthGuardProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    // Here we need to implement the logic to redirect user to the mindTime Form which will be just shown first
    const is2FAEnabled = localStorage.getItem('is2FAEnabled') === 'true';
    const isOtpVerified = localStorage.getItem('isOtpVerified') === 'true';
    const landingPath = getAuthenticatedLandingPath(user);

    // if user is authenticated, redirect to first allowed route
    if (isAuthenticated) {
        return <Navigate to={landingPath} replace />;
    }

    if (localStorage.getItem('accessToken')) {
        return <Navigate to="/" replace />;
    }

    // Add check for missing localStorage items
    if (!is2FAEnabled && !isOtpVerified) {
        return <Navigate to="/login" />;
    }

    return <>{children}</>;
};

TwoFactorAuthGuard.propTypes = {
    children: PropTypes.node,
};

export default TwoFactorAuthGuard;
